module.exports = __webpack_public_path__ + "fonts/Inter-400-cyrillic44.fdccea7.woff2";